/**
 * The window event that tells the layout whether any campaign wiki still has
 * unread reveals for the person (issue 1570), sent when Newly revealed's Mark
 * all read answers (`detail.unread`, the server's word for every campaign).
 * The header's marker starts from the session hydration (`/api/auth/me`'s
 * `wiki_unread`) and needs no request of its own. Kept apart from the wiki's
 * code so the layout, in the main chunk, can listen without pulling it in.
 */
export const WIKI_UNREAD_EVENT = 'tdt:wiki-unread';
